import {Box, Stack, Typography} from "@mui/material";
import * as React from "react";

type LegendShape = "bar" | "line" | "tick";

interface LegendEntryProps {
    label: string;
    color: string;
    shape?: LegendShape;
    width?: number;
    dashed?: boolean;
}

export function LegendEntry({label, color, shape = "line", width = 3, dashed = false}: LegendEntryProps) {
    return (
        <Stack direction={"row"} alignItems={"center"} spacing={0.75} sx={{minWidth: 0}}>
            {shape === "bar" && (
                <Box sx={{width: 12, height: 12, borderRadius: "3px", bgcolor: color, flexShrink: 0}}/>
            )}

            {shape === "line" && (
                <Box component={"svg"} viewBox={"0 0 18 4"} sx={{width: 18, height: 4, flexShrink: 0, overflow: "visible"}}>
                    <line
                        x1={0}
                        y1={2}
                        x2={18}
                        y2={2}
                        stroke={color}
                        strokeWidth={width}
                        strokeLinecap={"round"}
                        strokeDasharray={dashed ? "5 4" : undefined}
                    />
                </Box>
            )}

            {shape === "tick" && (
                <Box sx={{width: width, height: 14, borderRadius: "1px", bgcolor: color, flexShrink: 0, mx: "5px"}}/>
            )}

            <Typography sx={{color: "text.secondary", fontSize: 14, fontWeight: 600, lineHeight: "20px"}} noWrap>
                {label}
            </Typography>
        </Stack>
    );
}

interface InsightsLegendProps {
    children: React.ReactNode;
}

export function InsightsLegend({children}: InsightsLegendProps) {
    return (
        <Stack direction={"row"} alignItems={"center"} justifyContent={"center"} spacing={2.5} flexWrap={"wrap"} useFlexGap>
            {children}
        </Stack>
    );
}
